import { render, staticRenderFns } from "./CollectionSchedule1.vue?vue&type=template&id=f92c7256&scoped=true&"
import script from "./CollectionSchedule1.vue?vue&type=script&lang=js&"
export * from "./CollectionSchedule1.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSchedule1.vue?vue&type=style&index=0&id=f92c7256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92c7256",
  null
  
)

export default component.exports